module.exports = __webpack_public_path__ + "img/icon-banner-dex-cards-dark.e439e403.svg";